<template>
  <div class="general-info listing-cards-block">
    <div class="general-info__container">
      <div v-if="heading" class="general-info__title-left">
        <h1 class="text-TTDrugs-Bold-40 color-green center text-uppercase">{{ heading }}</h1>
      </div>
      <div class="article-list-departments__containers">
        <div class="article-list-departments__grid">
          <div
            v-for="(item, idx) in items"
            :key="idx"
            class="information-dynamic-block__item image-block-active"
            :style="{ cursor: item.link ? 'pointer' : 'default' }"
            @click="goTo(item)"
          >
            <div>
              <img
                v-if="item.image"
                :src="item.image"
                :alt="item.title || ''"
                class="image-block-active__img"
              >
            </div>
            <div class="image-overlay-active">
              <div class="overlay-content-active">
                <div class="overlay-content-start-active">
                  <p class="text-TTDrugs-bold-24 color-white">{{ item.title }}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AppListingCardsBlock',
  props: {
    data: {
      type: Object,
      required: true,
      default: () => ({}),
    },
  },
  computed: {
    heading() {
      return (this.data && this.data.heading) || ''
    },
    items() {
      const list = this.data && this.data.items
      return Array.isArray(list) ? list : []
    },
  },
  methods: {
    normalizeLink(link) {
      const raw = String(link || '').trim()
      if (!raw) return ''
      if (/^https?:\/\//i.test(raw)) return raw
      if (raw.startsWith('/')) return raw
      return `/${raw}`
    },
    goTo(item) {
      const href = this.normalizeLink(item && item.link)
      if (!href) return
      if (/^https?:\/\//i.test(href)) {
        window.location.href = href
        return
      }
      this.$router.push(href)
    },
  },
}
</script>

<style scoped>
</style>
